import styles from '@/pages/app/BillingOps/styles.module.scss'

import { CostCenterListItem } from '@/api/generated'

interface CostCenterPickerProps {
  costCenters: CostCenterListItem[]
  selectedId: string | null
  onSelect: (costCenter: CostCenterListItem) => void
}

const CostCenterPicker = ({ costCenters, selectedId, onSelect }: CostCenterPickerProps) => (
  <div className={styles.opList}>
    {costCenters.map((cc) => {
      const isActive = cc.id === selectedId
      const className = [styles.opItem, isActive ? styles.opItemActive : ''].filter(Boolean).join(' ')
      return (
        <button key={cc.id} className={className} onClick={() => onSelect(cc)} type="button">
          <span className={styles.opItemKind}>{cc.name}</span>
          <span className={styles.opItemDescription}>
            {cc.status}
            {cc.stripe_customer_id ? ` · ${cc.stripe_customer_id}` : ''}
          </span>
        </button>
      )
    })}
  </div>
)

export default CostCenterPicker
